<template>
    <a-layout>
        <Header>
            <template slot="head">
                <a-button icon="unordered-list" class="drawer-handler"
                    @click="showDrawer"
                ></a-button>
                <a-drawer
                    placement="left"
                    :closable="false" :visible="visible"
                    @close="onClose"
                >
                    <Menu></Menu>
                </a-drawer>
            </template>
        </Header>
        <a-layout>
            <a-layout-sider width="180" class="left-menu" style="background: #fff">
                <Menu></Menu>
            </a-layout-sider>
            <a-layout class="main-brench">
                <a-breadcrumb style="margin: 16px 0">
                    <a-breadcrumb-item>{{ $route.meta.title }}</a-breadcrumb-item>
                </a-breadcrumb>
                <a-layout-content class="main-content"
                    :style="{ background: '#fff', margin: 0, minHeight: '280px' }"
                >
                    <keep-alive>
                        <router-view/>
                    </keep-alive>
                </a-layout-content>
            </a-layout>
        </a-layout>
    </a-layout>
</template>

<script>
import Header from '@/components/Header'
import Menu from './Menu.vue'

export default {
    name: 'App',
    data: () => ({
        visible: false,
    }),
    methods: {
        showDrawer() {
            this.visible = true;
        },
        onClose() {
            this.visible = false;
        },
    },
    components: {
        Header, Menu
    },
};
</script>

<style lang="less" scoped>
.drawer-handler {
    margin: 15px;
    margin-left: 0px;
}
@media screen and (min-width: 600px) {
    .drawer-handler {
        display: none;
    }
    .main-brench {
        padding: 0 24px 24px
    }
    .main-content {
        padding: 24px
    }
}
@media screen and (max-width: 600px) {
    .left-menu {
        display: none;
    }
    .main-brench {
        padding: 0
    }
    .main-content {
        padding: 12px
    }
}
</style>